import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  PayItemConnection,
  useConnectionsContext,
} from '../../ConnectionsContext'
import { useRemovePayItemConnectionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'

export function useRemove(): RemoveRowActionOptions<PayItemConnection> {
  const { refetch } = useConnectionsContext()
  const [remove] = useRemovePayItemConnectionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemovePayItemConnection: {
        payItemConnection: { googleSheet, name },
      },
    }) => simpleRemoveNotification(name ?? googleSheet?.title ?? 'Connection'),
  })
  return {
    permission: Permission.RemoveRestorePayItemConnection,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
